import { render, staticRenderFns } from "./HistoryItemTypePromocode.vue?vue&type=template&id=6d79992a&scoped=true&"
import script from "./HistoryItemTypePromocode.vue?vue&type=script&lang=js&"
export * from "./HistoryItemTypePromocode.vue?vue&type=script&lang=js&"
import style0 from "./HistoryItemTypePromocode.vue?vue&type=style&index=0&id=6d79992a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d79992a",
  null
  
)

export default component.exports